import React, { memo, useCallback, MouseEventHandler } from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import { useTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import { DialogActions, makeStyles, Box } from '@material-ui/core'

import styles from './styles'
const useStyles = makeStyles(styles)

interface IDialogJobApplicants {
	open: boolean
	closeDialog: Function
	handleLogIn: MouseEventHandler<any>
	isUserLogged: boolean
}

const DialogJobApplicants: React.FunctionComponent<IDialogJobApplicants> = ({
	open,
	closeDialog,
	isUserLogged,
	handleLogIn,
}) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const handleClose = useCallback(() => {
		closeDialog()
	}, [closeDialog])

	return (
		<Dialog onClose={handleClose} aria-labelledby="upload-cv" open={open}>
			<DialogTitle id="upload-cv" className={classes.title}>
				{t(
					!isUserLogged
						? 'In order to apply for this job you need to be logged in and have a CV file uploaded.'
						: 'Please, go in your profile page and upload your CV before applying.',
				)}
			</DialogTitle>
			<Box component="div" className={classes.buttonsContainer}>
				{!isUserLogged && (
					<DialogActions>
						<Button
							onClick={handleLogIn}
							color="primary"
							classes={{ root: classes.logInButton }}
						>
							{t('Log In')}
						</Button>
					</DialogActions>
				)}

				<DialogActions>
					<Button
						onClick={handleClose}
						color="primary" // className={classes.logInButton}
					>
						{t('Close')}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	)
}

export default memo(DialogJobApplicants)
